"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchSubBusinessReducer = exports.fetchOutletsForFranchiseReducer = exports.fetchOutletsForOwnerReducer = exports.updateOutletReducer = exports.createOutletReducer = exports.fetchOutletReducer = exports.fetchSubBusinessSlice = exports.fetchOutletsForFranchiseSlice = exports.fetchOutletsForOwnerSlice = exports.updateOutletSlice = exports.createOutletSlice = exports.fetchOutletSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const outletAction_1 = require("./outletAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.fetchOutletSlice = (0, toolkit_1.createSlice)({
    name: 'outlet/fetch',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(outletAction_1.fetch.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(outletAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(outletAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.createOutletSlice = (0, toolkit_1.createSlice)({
    name: 'outlet/create',
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(outletAction_1.create.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(outletAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(outletAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.updateOutletSlice = (0, toolkit_1.createSlice)({
    name: 'outlet/update',
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(outletAction_1.update.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(outletAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(outletAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.fetchOutletsForOwnerSlice = (0, toolkit_1.createSlice)({
    name: 'outlet/fetchOutletsForOwner',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(outletAction_1.fetchOutletsForOwner.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(outletAction_1.fetchOutletsForOwner.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(outletAction_1.fetchOutletsForOwner.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.fetchOutletsForFranchiseSlice = (0, toolkit_1.createSlice)({
    name: 'outlet/fetchOutletsForFranchise',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(outletAction_1.fetchOutletsForFranchise.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(outletAction_1.fetchOutletsForFranchise.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(outletAction_1.fetchOutletsForFranchise.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.fetchSubBusinessSlice = (0, toolkit_1.createSlice)({
    name: 'outlet/fetchSubBusiness',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(outletAction_1.fetchSubBusiness.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(outletAction_1.fetchSubBusiness.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(outletAction_1.fetchSubBusiness.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.fetchOutletReducer = exports.fetchOutletSlice.reducer;
exports.createOutletReducer = exports.createOutletSlice.reducer;
exports.updateOutletReducer = exports.updateOutletSlice.reducer;
exports.fetchOutletsForOwnerReducer = exports.fetchOutletsForOwnerSlice.reducer;
exports.fetchOutletsForFranchiseReducer = exports.fetchOutletsForFranchiseSlice.reducer;
exports.fetchSubBusinessReducer = exports.fetchSubBusinessSlice.reducer;
